let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ay5JG")).then(() => parcelRequire('ei6Pl'));